import { AlertProps } from "contexts/UIContext/types";
import { useAppUI } from "contexts/UIContext";



function Alert(alert: AlertProps) {
  const { closeAlert } = useAppUI();


  return (
    alert ? (
      <div className="col-md-12 py-4">
        <div
          role="alert"
          className={
            `alert alert-${alert.type} alert-dismissible fade show`
          }
        >
          {alert.text}
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeAlert}
          />
        </div>
      </div>
    ) : null
  );
}

export default Alert;